import { Box, Dialog, IconButton } from '@mui/material';
import cssClasses from "./PreselectConfirmation.module.css";
import greenTick from "../../Assets/Images/Common/greenTick.jpeg";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import { useEffect } from 'react';
const useStyles = makeStyles((theme) => ({
    closeIcon: {
        cursor: "pointer",
        position: "absolute",
        right: "1.7rem",
        top: "1.7rem",
    },
}));
const Congratulation = ({ open, handleClose, time }) => {
    const classes = useStyles();
    console.log(time)
    useEffect(() => {
        setTimeout(() => {
            handleClose();
        }, time);
    }, [])
    return (
        <Dialog open={open} onClose={() => window.location.reload()}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    // mt: "12vh",
                }}>
                <Box
                    sx={{
                        // width: { xs: "80vw", sm: "50vw", md: "30vw" },
                        backgroundColor: 'white',
                        borderRadius: 3,
                        padding: { xs: '20px', sm: '50px', md: '50px' },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        boxShadow: 24,
                        gap: "2rem"
                    }}>
                    <Box
                        sx={{ display: 'flex', justifyContent: 'end', alignSelf: 'end' }}>
                        <span className={classes.closeIcon} onClick={() => { window.location.reload() }} tabIndex={0}>
                            <Close width={"1.2rem"} height={"1.2rem"} />
                        </span>
                    </Box>
                    <Box
                        sx={{ textAlign: 'center', mt: '10px' }}>
                        <img src={greenTick} alt="Success" height="100px" />
                    </Box>

                    <Box sx={{ textAlign: 'center', display: "flex", gap: "2rem", flexDirection: "column" }}>
                        <Box className={cssClasses.congratulations}>Congratulations!</Box>
                        <Box
                            sx={{ fontSize: '20px', fontWeight: '300' }}>
                            You have successfully Confirmed Preselect Unit.
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Dialog>
    );
};

export default Congratulation;